import { v4 as uuidv4 } from 'uuid'

import { CUSTOM_PRODUCT_DISCOUNT, initialProductValues } from '../../../fields'

export const createNewProduct = (order, discount) => ({
  id: uuidv4(), // create unique id for current row
  ...initialProductValues,
  order,
  [CUSTOM_PRODUCT_DISCOUNT]: discount
})

export const getMaxOrderAndDiscount = products => {
  const maxOrder = products.reduce((acc, product) => (product.order > acc ? product.order : acc), 0)

  // If all discounts are the same, apply that discount to the new row. Otherwise, do not add any discount.
  const firstProductDiscount = products[0]?.[CUSTOM_PRODUCT_DISCOUNT]
  const allDiscountsSame = products.every(product => product[CUSTOM_PRODUCT_DISCOUNT] === firstProductDiscount)
  return { maxOrder, discount: allDiscountsSame && products.length > 0 ? firstProductDiscount : 0 }
}
